const requestNotificationPermission = async () => {
  if (!('Notification' in window) || Notification.permission !== 'default') {
    return;
  }

  try {
    const permission = await Notification.requestPermission();
    console.log('Notification permission:', permission);
  } catch (error) {
    console.log('Notification permission request failed:', error);
  }
};

export const checkForAppUpdate = async () => {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  const registration = await navigator.serviceWorker.getRegistration('/');

  if (!registration) {
    return;
  }

  if (registration.waiting) {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    return;
  }

  await registration.update();

  if (registration.waiting) {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  }
};

// Register service worker and check for updates on every page load.
export const registerServiceWorker = () => {
  // Local dev and preview must not retain an old production worker. It can
  // serve stale optimized React modules after a rebuild.
  const isLocalHost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  if (import.meta.env.DEV || isLocalHost) {
    if (isLocalHost && 'serviceWorker' in navigator) {
      void navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => void registration.unregister());
      });
    }
    return;
  }

  // Never reload an OAuth callback URL. Auth0 transactions are single-use, so
  // a service-worker update during the callback would replay the code and
  // surface a misleading "Invalid state" error.
  const isAuthCallback =
    window.location.pathname === '/callback' &&
    new URLSearchParams(window.location.search).has('code');

  if (isAuthCallback) {
    return;
  }

  if ('serviceWorker' in navigator) {
    let refreshing = false;

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) {
        return;
      }

      refreshing = true;
      window.location.reload();
    });

    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js', { updateViaCache: 'none' })
        .then((registration) => {
          console.log('SW registered: ', registration);

          if (registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          }

          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;

            newWorker?.addEventListener('statechange', () => {
              if (
                newWorker.state === 'installed' &&
                navigator.serviceWorker.controller
              ) {
                newWorker.postMessage({ type: 'SKIP_WAITING' });
              }
            });
          });

          return registration.update();
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        })
        .finally(() => {
          void requestNotificationPermission();
        });
    });
  } else {
    window.addEventListener('load', () => {
      void requestNotificationPermission();
    });
  }
};
